
const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://irisimpulse.com/#organization",
  name: "Iris Impulse India Pvt. Ltd.",
  url: "https://irisimpulse.com/",
  logo: "https://irisimpulse.com/logo.png",
  description:
    "Iris Impulse India Pvt. Ltd. is a bentonite manufacturer & industrial minerals exporter from India supplying quality minerals for drilling, paper, industrial sectors worldwide.",
  email: "rajan@irisimpulse.com",
  telephone: "+919638482211",
  address: {
    "@type": "PostalAddress",
    streetAddress: "IRIS HOUSE, Plot-39, Ward-7/C, Gurukul Road",
    addressLocality: "Gandhidham",
    addressRegion: "Gujarat",
    postalCode: "370201",
    addressCountry: "IN",
  },
  sameAs: [
    "https://www.linkedin.com/company/iris-impulse-india-private-limited/",
    "https://www.facebook.com/Irisimpulsebentonite",
    "https://www.youtube.com/@IrisImpulseIndia",
  ],

  areaServed: [
    // Europe
    { "@type": "Country", name: "Poland" },
    { "@type": "Country", name: "Spain" },
    { "@type": "Country", name: "Germany" },
    { "@type": "Country", name: "Finland" },
    { "@type": "Country", name: "France" },
    { "@type": "Country", name: "United Kingdom" },
    { "@type": "Country", name: "Greece" },
    { "@type": "Country", name: "Netherlands" },
    { "@type": "Country", name: "Norway" },
    { "@type": "Country", name: "Italy" },
    { "@type": "Country", name: "Russia" },
    { "@type": "Country", name: "Croatia" },

    // Southeast Asia
    { "@type": "Country", name: "Vietnam" },
    { "@type": "Country", name: "Thailand" },
    { "@type": "Country", name: "Malaysia" },
    { "@type": "Country", name: "Indonesia" },
    { "@type": "Country", name: "Philippines" },
    { "@type": "Country", name: "Singapore" },
    { "@type": "Country", name: "Cambodia" },

    // Asia
    { "@type": "Country", name: "China" },
    { "@type": "Country", name: "Taiwan" },
    { "@type": "Country", name: "Japan" },
    { "@type": "Country", name: "Sri Lanka" },
    { "@type": "Country", name: "Bangladesh" },
    { "@type": "Country", name: "Hong Kong" },
    { "@type": "Country", name: "India" },
    { "@type": "Country", name: "South Korea" },
    { "@type": "Country", name: "Bhutan" },

    // Africa
    { "@type": "Country", name: "Egypt" },
    { "@type": "Country", name: "Ethiopia" },
    { "@type": "Country", name: "Kenya" },
    { "@type": "Country", name: "Uganda" },
    { "@type": "Country", name: "Tanzania" },
    { "@type": "Country", name: "South Africa" },
    { "@type": "Country", name: "Mozambique" },
    { "@type": "Country", name: "Ghana" },
    { "@type": "Country", name: "Tunisia" },

    // Middle East
    { "@type": "Country", name: "Saudi Arabia" },
    { "@type": "Country", name: "Qatar" },
    { "@type": "Country", name: "Oman" },
    { "@type": "Country", name: "United Arab Emirates" },
    { "@type": "Country", name: "Kuwait" },
    { "@type": "Country", name: "Bahrain" },
    { "@type": "Country", name: "Israel" },
    { "@type": "Country", name: "Jordan" },
    { "@type": "Country", name: "Iraq" },
    { "@type": "Country", name: "Syria" },
    { "@type": "Country", name: "Iran" },

    // Oceania
    { "@type": "Country", name: "Australia" },

    // South America
    { "@type": "Country", name: "Peru" },
    { "@type": "Country", name: "Brazil" },
  ],
});

export default organizationSchema;
